// extracted by mini-css-extract-plugin
module.exports = {"categoryWrapper":"BusinessCategorySelect_categoryWrapper__2Peye"};